import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Role } from '../classes/index';

@Injectable()
export class RoleService {

	constructor(private firestore: Firestore) {
	}

	listRoles(collectionPath) {
		return collectionData(query(collection(this.firestore, collectionPath)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				delete data.collectionPath;
				let role = new Role(collectionPath);
				role.fromJSON(data);
				return role;
			});
		}))
		.pipe(map(roles => roles.sort((a, b) => {
			if (a.labels['fr'] > b.labels['fr']) return 1;
			else if (a.labels['fr'] < b.labels['fr']) return -1;
			else return 0;
		})));
	}

	getRoles(collectionPath){
		return collectionData(query(collection(this.firestore, collectionPath)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				delete data.collectionPath;
				let role = new Role(collectionPath);
				role.fromJSON(data);
				return role;
			});
		}));
	}

	addRole(role) {
		let data = { ...role };
		delete data.collectionPath;
		return addDoc(collection(this.firestore, role.collectionPath), {...data});
	}

	setRole(role) {
		let data = { ...role };
		delete data.collectionPath;
		return setDoc(doc(this.firestore, role.collectionPath, role.id), data);
	}

	/*async updateAllRole(templateObjects){
		var batch = this.afs.firestore.batch();
		for(let j = 0; j < templateObjects.length; j++){
			let objectsGames = templateObjects[j].changes
			for(let i = 0; i < objectsGames.length; i++){
				templateObjects[j].collectionPath = firebase.firestore.FieldValue.delete();
				batch.update(this.afs.collection(objectsGames[i].collectionPath).doc(`${objectsGames[i].id}`).ref,
					{labels:templateObjects[j].labels, description:templateObjects[j].description, pictureLastUpdate: templateObjects[j].pictureLastUpdate})				
			}
		}
		await batch.commit();	
	}*/

	updateRole(role, data){
		data.collectionPath = deleteField();
		return updateDoc(doc(this.firestore, role.collectionPath, role.id), data);
	}

	deleteRole(role) {
		return deleteDoc(doc(this.firestore, role.collectionPath, role.id));
	}
}

